import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "various-arrow-selected",
  "use": "various-arrow-selected-usage",
  "viewBox": "0 0 24 19",
  "content": "<symbol viewBox=\"0 0 24 19\" xmlns=\"http://www.w3.org/2000/svg\" id=\"various-arrow-selected\"><path d=\"M9.984 11V5.012l14 7-14 7V13H0V0h2v11h7.984z\" fill=\"#e3000f\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol